import { styled as muiStyled, Stack, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const ModalTitle = muiStyled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '100%',
  textAlign: 'left',
  color: NEW_COLORS.PRIMARY[500],
}));

const ModalDescription = muiStyled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  textAlign: 'left',
  display: 'inline',
}));

const TitleBox = muiStyled(Stack)(() => ({
  padding: '16px 24px',
  gap: '8px',
}));

const IconBox = muiStyled(Stack)(() => ({
  height: '32px',
  width: '32px',
  borderRadius: '50%',
  backgroundColor: NEW_COLORS.SECONDARY[50],
}));

export { IconBox, TitleBox, ModalTitle, ModalDescription };
